export default __webpack_public_path__ + "static/floating-light-aad4a2f30a256c7fd2fc0813a13e387c9a5629a249915d152facf9dbc345fa06.png";